import { renderInline } from './richInline'

export function RichText({ text, className = '', paragraphClassName = '' }) {
  const paragraphs = String(text ?? '').split(/\n\s*\n/).filter((p) => p.trim())
  if (paragraphs.length === 0) return null
  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      {paragraphs.map((p, i) => <p key={i} className={paragraphClassName}>{renderInline(p)}</p>)}
    </div>
  )
}

export default RichText
